import {Injectable} from '@angular/core';
import {QueryStringService} from '@xref/ngx';
import * as Cookies from 'js-cookie';

import {environment} from '../../../environments/environment';
import Constants from '../../shared/constants';
import {IdService} from "../id/id.service";

declare global {
    interface Window {
        DD_RUM: any;
        DD_LOGS: any;
    }
}

@Injectable()
export class AuthService {
    url = `${environment.AUTH_API}`;
    region = 'au';
    returnUrl = '';

    constructor(
        private id: IdService,
        private qs: QueryStringService
    ) {
    // Get return URL query param
        this.returnUrl = decodeURIComponent(this.qs.getParam('retUrl'));

        // If available, store in Cookie. This allows for allowing redirects in SSO etc workflows that leaves platform
        if (this.returnUrl && this.returnUrl != 'null') Cookies.set(Constants.RETURN_URL, this.returnUrl, { domain: environment.DOMAIN });
    }

    setRegionalUrl(region: string) {
        this.url = this.makeRegionalUrl(region, environment.AUTH_API);
    }

    makeRegionalUrl(region: string, url: string): string {
        if (region && region.toLowerCase() !== 'au') {
            this.region = region;
            const api = url.slice(0, url.indexOf('.'));
            const domain = url.slice(url.indexOf('.') + 1);

            return `${api}-${region}.${domain}`;
        } else {
            return url;
        }
    }

}
